<!-- <p-progressSpinner *ngIf="!dashboardMetricSet || !dashboardMetricSet.initialized" [style]="{width: '50px', height: '50px'}" fxFlex="1 1 auto" class="spinner"  animationDuration="2s"></p-progressSpinner> -->
<div fxLayout="column">
    <div fxFlex="1 1 auto" class='dashboard-metric-type'>
        <span>{{dashboardMetricSet.label}}</span>
    </div>
    <div fxFlex="1 1 auto" fxLayout="row">
        <div class="metric-holder" fxFlex="1 1 100%">
            <div fxLayout="row" *ngIf="dashboardMetricSet">
                <!-- <span class="dashboard-metric-top-badge">1</span> -->
                <mat-icon fxFlex="0 1 auto" [ngClass]="'badge dashboard-metric-color-' + (dashboardMetricSet.categoryIndex+1)">looks_one</mat-icon>
                <div fxFlex="1 1 auto" fxLayout="column">
                    <span fxFlex="1 1 auto" class="dashboard-metric-value-med dashboard-metric-center">{{dashboardMetricSet.values[0] || '--'}}</span>
                    <span fxFlex="1 1 auto" class="dashboard-metric-date">{{dashboardMetricSet.dates[0]}}</span>
                </div>
                <!-- <span class="dashboard-metric-top-badge">2</span> -->
                <mat-icon fxFlex="0 1 auto" [ngClass]="'badge dashboard-metric-color-' + (dashboardMetricSet.categoryIndex+1)">looks_two</mat-icon>
                <div fxFlex="1 1 auto" fxLayout="column">
                    <span fxFlex="1 1 auto" class="dashboard-metric-value-med dashboard-metric-center">{{dashboardMetricSet.values[1] || '--'}}</span>
                    <span fxFlex="1 1 auto" class="dashboard-metric-date">{{dashboardMetricSet.dates[1]}}</span>
                </div>
                <!-- <span class="dashboard-metric-top-badge">3</span> -->
                <mat-icon fxFlex="0 1 auto" [ngClass]="'badge dashboard-metric-color-' + (dashboardMetricSet.categoryIndex+1)">looks_3</mat-icon>
                <div fxFlex="1 1 auto" fxLayout="column">
                    <span fxFlex="1 1 auto" class="dashboard-metric-value-med dashboard-metric-center">{{dashboardMetricSet.values[2] || '--'}}</span>
                    <span fxFlex="1 1 auto" class="dashboard-metric-date">{{dashboardMetricSet.dates[2]}}</span>
                </div>
                <!-- <span fxFlex="1 1 5%" [ngClass]="'dashboard-metric-center-icon fa fa-' + riskMetric.centerIcon"></span> -->
            </div>
        </div>
    </div>
</div>